import {enum_loginMethods} from "../../functions/src/shareCode/Share_S_Enum";


let ios_endPointsNames = {
    ios_takeImage       : "ios_takeImage",
    ios_takeVideo       : "ios_takeVideo",
    ios_log             : "ios_log",
    ios_loginGoogle     : "ios_loginGoogle",
    ios_loginFacebook   : "ios_loginFacebook",
    ios_logout          : "ios_logout",
    ios_getBatteryLevel : "ios_getBatteryLevel",
    ios_notification    : "ios_notification",
    ios_geoLocationListener_set    : "ios_geoLocationListener_set",
    ios_geoLocationListener_stop    : "ios_geoLocationListener_stop",
    ios_keyboardListener    : "ios_keyboardListener",
    ios_qrScanner    : "ios_qrScanner",
    ios_getVersion    : "ios_getVersion",
}


// ios_takeVideo_f
export const ios_takeVideo_f = (cb_f) => {

    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_takeVideo,
        cb_f            : cb_f,
    })

}

// ios_log_f
export const ios_logMe_f = (msg_s) => {

    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_log,
        cb_f            : () => {},
        data            : {msg_s : msg_s}
    })
}

// ios_loginGoogle_f
export const ios_loginWithProvider_f = (provider_e, cb_f) => {

    switch (provider_e){
        case enum_loginMethods.google:
            callEndPoint_f({
                endPointName    : ios_endPointsNames.ios_loginGoogle,
                cb_f            : cb_f,
            })
            break;
        case enum_loginMethods.facebook:
            callEndPoint_f({
                endPointName    : ios_endPointsNames.ios_loginFacebook,
                cb_f            : cb_f,
            })
            break;
    }
}

// ios_logout_f
export const ios_logout_f = () => {

    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_logout,
    })

}

// android_setKeyboardOnChangeListener_f
export const ios_setKeyboardOnChangeListener_f = (cb_f) => {

    callEndPoint_f({
        endPointName  : ios_endPointsNames.ios_keyboardListener,
        cb_f        : (keyboardStatus_b) => {
            cb_f(JSON.parse(keyboardStatus_b))
        }})

}

// ios_getBatteryLevel_f
export const ios_getBatteryLevel_f = (cb_f) => {

    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_getBatteryLevel,
        cb_f    : (batteryLevel_s) => {
            cb_f(parseInt(parseFloat(batteryLevel_s) * 100))
        },
    })

}

// ios_takeImage_f
export const ios_takeImage_f = (cb_f) => {

    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_takeImage,
        cb_f        : cb_f
    })

}

// ios_notification_chat
export const ios_notification_chat = (title_s, msg_s) => {

    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_notification,
        data : {
            title_s : title_s,
            msg_s : msg_s,
        }
    })

}

// ios_geoLocationListener_set_f
export const ios_geoLocationListener_set_f = (cb_f) => {
    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_geoLocationListener_set,
        cb_f            : (object_s) => {
            cb_f(JSON.parse(object_s))
        },
    })

}

// ios_geoLocationListener_stop_f
export const ios_geoLocationListener_stop_f = () => {
    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_geoLocationListener_stop,
    })

}

// ios_geoLocationListener_stop_f
export const ios_qrScanner_f = (cb_f) => {

    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_qrScanner,
        cb_f : cb_f
    })

}

// ios_getVersion
export const ios_getVersion = (cb_f) => {

    callEndPoint_f({
        endPointName    : ios_endPointsNames.ios_getVersion,
        cb_f : cb_f
    })

}




// ========== private function ====================

// callEndPoint_f
const callEndPoint_f = ({endPointName, cb_f, data}) => {

    if(cb_f == null){
        cb_f = (msg) => {}
    }

    if(data == null){
        data = {}
    }

    let callBackName_s = endPointName + "_cb"
    window[callBackName_s] = cb_f

    try {
        webkit.messageHandlers.TqApi.postMessage({
            endPointName : endPointName,
            cbName : callBackName_s,
            data : data
        })
    }catch (e) {}
}

